// src/services/ga4Service.ts
import { getApiBaseUrl } from "src/config/Endpoints";
import { buildAuthHeaders, handleJsonResponse } from "./HttpUtils";

const API_BASE_URL = getApiBaseUrl();

// Helper to handle API response
export const ga4Service = {
  // 1. Fetch existing GA4 connection details
  fetchExistingConnection: async (
    tenant_id: string | null,
    api_key: string | null
  ): Promise<any> => {
    const response = await fetch(
      `${API_BASE_URL}/ga4/fetch-existing-account-details?tenant_id=${tenant_id}`,
      {
        method: "POST",
        headers: buildAuthHeaders("api_key"),
      }
    );
    return handleJsonResponse(response);
  },

  // 2. Fetch accounts
  fetchAccounts: async (access_token: string): Promise<any> => {
    const response = await fetch(`${API_BASE_URL}/ga4/accounts`, {
      method: "POST",
      headers: buildAuthHeaders("api_key"),
      body: JSON.stringify({ access_token }),
    });
    return handleJsonResponse(response);
  },

  // 3. Fetch properties
  fetchProperties: async (
    access_token: string,
    account_id: string
  ): Promise<any> => {
    const response = await fetch(`${API_BASE_URL}/ga4/properties`, {
      method: "POST",
      headers: buildAuthHeaders("api_key"),
      body: JSON.stringify({ access_token, account_id }),
    });
    return handleJsonResponse(response);
  },

  // 4. Create connection
  createConnection: async (params: {
    refresh_token: string;
    property_id: string;
    account_id: string;
    tenant_id: string;
    source: string;
    user_id: string;
    metadata_status: string;
  }): Promise<any> => {
    const response = await fetch(`${API_BASE_URL}/ga4/create-connection`, {
      method: "POST",
      headers: buildAuthHeaders("api_key"),
      body: JSON.stringify(params),
    });
    return handleJsonResponse(response);
  },

  // 5. Test connection
  testConnection: async (params: {
    access_token: string;
    property_id: string;
    tenant_id: string;
    user_id: string;
  }): Promise<any> => {
    const response = await fetch(`${API_BASE_URL}/ga4/test-connection`, {
      method: "POST",
      headers: buildAuthHeaders("api_key"),
      body: JSON.stringify(params),
    });
    return handleJsonResponse(response);
  },

  // 6. Remove connection
  removeConnection: async (
    tenant_id: string,
    api_key: string
  ): Promise<any> => {
    const response = await fetch(
      `${API_BASE_URL}/remove-connection?tenant_id=${tenant_id}&source_name=google_analytics4`,
      {
        method: "POST",
        headers: buildAuthHeaders("api_key"),
      }
    );
    return handleJsonResponse(response);
  },

  // 7. Fetch metadata
  fetchMetadata: async (params: {
    access_token: string;
    property_id: string;
  }): Promise<any> => {
    const response = await fetch(`${API_BASE_URL}/ga4/metadata`, {
      method: "POST",
      headers: buildAuthHeaders("api_key"),
      body: JSON.stringify(params),
    });
    return handleJsonResponse(response);
  },
};

